export const enum SurveyAnswerTypeIdEnum {
  RADIO_GROUP = 2, // Один вариант ответа
  CHECKBOX_GROUP = 3, // Несколько вариантов ответа
  TEXT_SHORT = 4, // Небольшое текстовое поле
  HAPPY_INDEX_5 = 5, // Шкала от 1 до 5
  HAPPY_INDEX_10 = 6, // Шкала от 1 до 10
  TEXT_LONG = 7, // Большое текстовое поле
}
